<template>
	<div class="home">
    <v-container>
      <v-row>
        <v-col cols="12">
          <h3>RemoteLab</h3>
          <h6> is an online experiment platform for you to perform experiments anytime, anywhere.</h6>
        </v-col>
      </v-row>
      <v-row>
        <v-col sm="12" md="3">
          <h5>Anytime, Anywhere</h5>
          <blockquote class="blockquote">Students and/or teachers can operate such setups in a way similar to running the experiment in school laboratories, at any time and from everywhere.</blockquote>
        </v-col>
        <v-col sm="12" md="3">
          <h5>Centralized, Qualified</h5>
          <blockquote class="blockquote">All experiments are centralized in the Department of Applied Physics, qualified and maintained by our professors and university staffs.</blockquote>
        </v-col>
        <v-col sm="12" md="3">
          <h5>Learning, Teaching</h5>
          <blockquote class="blockquote">Highly flexible for adaptation in different learning and teaching modes, suitable for class demonstrations, individual/group assignments and investigations.</blockquote>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <h3>Developed by Department of Applied Physics, PolyU</h3>
          <h6>Starting 2010, the Department of Applied Physics (AP) has launched a centralized depository of selected physics experiments. While the initial goal of the platform was for PolyU undergraduates admitted to AP’s service-teaching subjects, the idea has since gained popularity and is now also available for senior secondary school students.</h6>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <h3>Supported by QEF & PolyU</h3>
          <h6>The Remote Lab was financially supported by Quality Education Fund of Hong Kong Special Administrative Region Government (QEF, HKSAR) and the Hong Kong Polytechnic University (HK PolyU).</h6>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <h3>RemoteLab Won Reimagine Education Asia Gold Award!</h3>
          <h6>The RemoteLab project was awarded the "Asia Gold Award" in the Wharton-QS Stars Reimagine Education 2016 Competition, for creating a novel, true-to-life remote laboratory to enhance student understanding of experimental methodologies and outcomes. The RemoteLab is the first-of-its-kind in Asia, and has enabled students to conduct experiments everywhere at all times.</h6>
        </v-col>
      </v-row>
    </v-container>
	</div>
</template>

<script>

export default {
  name: 'Home',
  components: {
  },
};
</script>
